import React from "react";
import { SkillsData } from "../data";
import Products from "./Products";

const Skills = () => {
  return (
    <>
      <section className="skills-section">
        <div className="row">
          <div className="skills">
            <h2 className="heading">skills</h2>

            <Products product={SkillsData} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Skills;
